import style from "./style.scss";

import { Fragment } from "preact";
import Link from "../link";
import Accordion from "../accordion";
import { isUrlWithScheme } from "../helpers";

const CandidateBio = ({
  img,
  name,
  since,
  email,
  questions = null,
  links = null,
  children,
}) => (
  <div class={style.candidateBio}>
    <div class={style.aside}>
      <div class={style.image}>
        <img src={img} alt={name} />
      </div>
      {questions ? (
        <div class={style.underInfo}>
          <Link href="#questions">Jump to Q&A</Link>
        </div>
      ) : null}
    </div>

    <div class={style.info}>
      {/* <h2>{name}'s Bio</h2> */}

      <div>{children}</div>

      <em class={style.signature}>{name}</em>

      <p>
        <Link rel="noreferrer" href={`mailto:${email}`}>
          {email}
        </Link>
      </p>

      {questions ? (
        <Fragment>
          <h2 id="questions">Questions &amp; Answers</h2>
          <Accordion items={questions} />
        </Fragment>
      ) : null}

      <ul class={style.buttonList}>
        <li>
          <Link class="button" href="/#endorsed">
            View Our Other Candidates
          </Link>
        </li>
        {links
          ? links.map((link) => {
              return (
                <li key={link.text}>
                  {isUrlWithScheme(link.href) ? (
                    <Link
                      class="button secondary"
                      target="_blank"
                      rel="noreferrer"
                      href={link.href}
                    >
                      {link.text}
                    </Link>
                  ) : (
                    <Link class="button secondary" href={link.href}>
                      {link.text}
                    </Link>
                  )}
                </li>
              );
            })
          : null}
      </ul>
    </div>
  </div>
);

export default CandidateBio;
